import React, {useRef, useState} from 'react';
import {Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import {Breadcrumbs, Btn, H5} from '../../../../AbstractElements';
import ButtonIcon from '../../../../CommonElements/ButtonIcon';
import MultimediaTable from '../Component/MultimediaTable';
import MultimediaUploadForm from '../Component/MultimediaUploadForm';
import type {Multimedia, MultimediaTableRef} from '../Types/MultimediaTypes';

const MultimediaIndex: React.FC = () => {
    const [uploadModalVisibility, setUploadModalVisibility] = useState<boolean>(false);
    const multimediaTableRef = useRef<MultimediaTableRef>(null);

    const multimediaModalToggle = () => {
        setUploadModalVisibility(!uploadModalVisibility);
    };

    const addMultimedia = (multimedia: Multimedia) => {
        multimediaTableRef.current?.addMultimedia(multimedia);
        multimediaModalToggle();
    };

    const getMultimedia = () => {
        multimediaTableRef.current?.getMultimedia();
    };

    return (
        <div>
            <Breadcrumbs mainTitle='Multimedia' parent='Settings' title='Multimedia'/>
            <Container fluid={true}>
                <Row>
                    <Col sm='12'>
                        <Card>
                            <CardHeader className='d-flex align-items-center justify-content-between'>
                                <H5>Multimedia</H5>
                                <div className='d-flex align-items-center gap-2'>
                                    <ButtonIcon
                                        attrBtn={{onClick: () => setUploadModalVisibility(true)}}
                                        type={'add'}
                                        permission={'create-multimedia'}
                                    />
                                    <ButtonIcon
                                        attrBtn={{onClick: getMultimedia}}
                                        type={'sync'}
                                        permission={'read-multimedia'}
                                    />
                                </div>
                            </CardHeader>
                            <CardBody>
                                <MultimediaTable ref={multimediaTableRef}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={uploadModalVisibility} toggle={multimediaModalToggle} centered>
                <ModalHeader>Upload Multimedia</ModalHeader>
                <ModalBody>
                    <MultimediaUploadForm callBack={addMultimedia}/>
                </ModalBody>
                <ModalFooter>
                    <Btn attrBtn={{color: 'primary', onClick: multimediaModalToggle}}>Close</Btn>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default MultimediaIndex;
